/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import {getTestProps} from '@benchling/js-test-utils';
import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import wyciwyp from 'notebook/mediocre/clipboard/wyciwyp';
import notifications from 'notifications';
import DragDropUpload from 'util/DragDropUpload';

// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

const DROP_EFFECT = {
  NONE: null,
  ALLOWED: 'drop-allowed',
  DISALLOWED: 'drop-disallowed',
};

interface Props {
  className?: string;
  onDrop: (...args: Array<any>) => any;
  onSetDropEffect?: (...args: Array<any>) => any;
  shouldCaptureDrop: boolean;
  mimeTypes: Array<string>;
  validateDrop?: (...args: Array<any>) => any;
  dropEffect: string;
  targetDesc: string;
  component: string | React.ComponentType;
}

type State = any;

class DropTarget extends React.Component<Props, State> {
  static dropErrorMessage(targetDesc: any): string {
    return `Unable to move dragged item into ${targetDesc}.`;
  }

  static DROP_EFFECT = DROP_EFFECT;

  static defaultProps = {
    component: 'div',
  };

  override state: State = {
    dropEffect: DROP_EFFECT.NONE,

    // A list of DOM nodes that have been dragged over.
    // dragenter/dragleave behaves like mouseover/mouseout instead of like mouseenter/mouseleave, so we
    // maintain this list ourselves. A counter normally would suffice but Firefox fires multiple dragenter
    // events. See: https://bugzilla.mozilla.org/show_bug.cgi?id=804036
    _dragCollection: [],
  };

  validateDrop = (e: any): string | null => {
    if (
      !_.any(
        Array.from(this.props.mimeTypes).map((mimeType) =>
          Array.from(e.dataTransfer.types).includes(mimeType)
        )
      )
    ) {
      return DropTarget.dropErrorMessage(this.props.targetDesc);
    } else if (this.props.validateDrop) {
      return this.props.validateDrop(e);
    } else {
      return null;
    }
  };

  setEventDropEffect = (e: any): void => {
    e.dataTransfer.dropEffect =
      Array.from(this.props.mimeTypes).includes('Files') &&
      wyciwyp.typesContains(e.dataTransfer.types, 'Files')
        ? // If we are dealing with a file, the correct dropEffect is 'copy' since we will be copying the data
          // to our server, even if normally we are linking (@props.dropEffect == 'link')
          // Also, if we don't use 'copy', the drop event may not fire, since the allowedEffect may exclude
          // link (e.g. 'moveCopy' for dragging a file from Chrome's download bar)
          'copy'
        : this.props.dropEffect;
  };

  updateDropEffect = (): void => {
    if (this.state._dragCollection.length === 0) {
      this.setState({dropEffect: DROP_EFFECT.NONE});
      if (typeof this.props.onSetDropEffect === 'function') {
        this.props.onSetDropEffect(DROP_EFFECT.NONE);
      }
    }
  };

  dragCountIncrement = (e: any): void => {
    // eslint-disable-next-line no-restricted-syntax
    const index = _.indexOf(this.state._dragCollection, e.target);
    if (index === -1) {
      this.state._dragCollection.push(e.target);
      this.updateDropEffect();
    }
  };

  dragCountDecrement = (e: any): void => {
    // eslint-disable-next-line no-restricted-syntax
    const index = _.indexOf(this.state._dragCollection, e.target);
    if (index !== -1) {
      this.state._dragCollection.splice(index, 1);
      this.updateDropEffect();
    }
  };

  dragCountClear = (): void => {
    this.state._dragCollection.splice(0, this.state._dragCollection.length); // clear the array
    this.updateDropEffect();
  };

  _shouldIgnoreDrop = (): boolean =>
    // This component interferes with DragDropUpload,
    // so we let DragDropUpload handle events if it is currently active
    DragDropUpload.isActive() || !this.props.shouldCaptureDrop;

  dragLeaveHandler = (e: any): void => {
    if (e.isDefaultPrevented()) {
      // a child is a DropTarget that has taken the count.
      return;
    }
    if (this._shouldIgnoreDrop()) {
      return;
    }
    this.dragCountDecrement(e);
    e.preventDefault();
  };

  dragEnterHandler = (e: any): void => {
    if (e.isDefaultPrevented()) {
      this.dragCountClear(); // a child is a DropTarget that wants to be dragged on.
      return;
    }
    if (this._shouldIgnoreDrop()) {
      return;
    }
    this.dragCountIncrement(e);
    e.preventDefault();

    this.setEventDropEffect(e);
    const hasError = this.validateDrop(e) != null;
    const dropEffect = hasError ? DROP_EFFECT.DISALLOWED : DROP_EFFECT.ALLOWED;
    this.setState({dropEffect});
    if (typeof this.props.onSetDropEffect === 'function') {
      this.props.onSetDropEffect(dropEffect);
    }
  };

  dragOverHandler = (e: any): void => {
    if (e.isDefaultPrevented() || this._shouldIgnoreDrop()) {
      return;
    }
    e.preventDefault();
    this.setEventDropEffect(e);
  };

  dropHandler = (e: any): void => {
    this.dragCountClear();
    if (e.isDefaultPrevented()) {
      return;
    }
    if (this._shouldIgnoreDrop()) {
      return;
    }
    e.preventDefault();

    const errorMsg = this.validateDrop(e);
    if (errorMsg != null) {
      notifications.warn(errorMsg, {id: 'DropTarget.dropHandler'});
    } else {
      this.props.onDrop(e);
    }
  };

  override render(): JSX.Element {
    // eslint-disable-next-line no-restricted-syntax
    const propsForComponent = _.omit(
      this.props,
      'className',
      'shouldCaptureDrop',
      'onSetDropEffect',
      'mimeTypes',
      'validateDrop',
      'dropEffect',
      'targetDesc',
      'component'
    );
    return React.createElement(
      this.props.component,
      {
        ...propsForComponent,
        ...getTestProps({component: 'DropTarget', element: 'root'}),
        className: classNames(this.props.className, {
          'dnd-drop-container': true,
          'is-interacting-allowed': this.state.dropEffect === DROP_EFFECT.ALLOWED,
          'is-interacting-disallowed': this.state.dropEffect === DROP_EFFECT.DISALLOWED,
        }),
        onDragLeave: this.dragLeaveHandler,
        onDragEnter: this.dragEnterHandler,
        onDragOver: this.dragOverHandler,
        onDrop: this.dropHandler,
      },
      this.props.children,
      this.props.component === DropTarget.defaultProps.component ? (
        <div className="dnd-drop-container-border" />
      ) : undefined
    );
  }
}

export default DropTarget;
